import ResponsibleDevelopmentIndex from "../../../../src/courses/partials/responsible-development/index.mdx";
import * as React from 'react';
export default {
  ResponsibleDevelopmentIndex,
  React
};